import Color from 'color';
import { icon_sync_message } from 'components/base/images';
import MuiButton from 'components/common/button/MuiButton';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import React from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import CustomSpan from 'components/common/text/CustomSpan';

interface SyncMessageProps {
  projectInfo: object | any;
  onEditProjectSync: (syncStatus: number) => void;
}

function SyncMessage({ projectInfo, onEditProjectSync }: SyncMessageProps) {
  const { ownerName } = projectInfo;

  return (
    <StyledSyncMessage data-component-name="SyncMessage">
      <div className="syncMessage__container">
        <div className="syncMessage__contents_box message">
          <div className="syncMessage__icon_box">
            <img src={icon_sync_message} />
          </div>
          <div className="syncMessage__message_box">
            <p>
              <CustomSpan fontColor={color.blue} marginRight={10}>
                [ <T>GLOBAL_INVITED</T> ]
              </CustomSpan>

              <T>GLOBAL_INVITED_TEXT</T>
            </p>

            <CustomText>{ownerName}</CustomText>
          </div>
        </div>
        <div className="syncMessage__contents_box button">
          <MuiButton
            config={{
              color: color.white,
            }}
            disableElevation
            variant="outlined"
            className="xl syncMessage__contents_button reject"
            onClick={() => onEditProjectSync(2)}
          >
            <T>PROJECT_INVITED_REJECT</T>
          </MuiButton>
          <MuiButton
            config={{
              color: color.white,
              fontColor: '#25256F',
            }}
            disableElevation
            variant="contained"
            className="xl syncMessage__contents_button accept"
            onClick={() => onEditProjectSync(1)}
          >
            <T>PROJECT_INVITED_ACCEPT</T>
          </MuiButton>
        </div>
      </div>
    </StyledSyncMessage>
  );
}

export default React.memo(SyncMessage);

const StyledSyncMessage = styled.div`
  position: absolute;
  z-index: 110;
  width: 100%;
  .syncMessage__container {
    width: 100%;
    height: 90px;
    background-color: #25256f;
    border-radius: 6px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .syncMessage__contents_box {
      display: flex;
      &.message {
        column-gap: 20px;
      }
      &.button {
        column-gap: 10px;
      }
      .syncMessage__contents_button {
        width: 190px;
        height: 46px;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .syncMessage__icon_box {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .syncMessage__message_box {
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 10px;
      font-size: 16px;
      font-weight: 400;
    }
  }
`;
